import { Col, Container, Input, Row } from "reactstrap";
import Pagination from "../../../components/common/pagination";
import { useMemo, useState } from "react";
import useFetch from "../../../components/shared/hooks/api/fetch";
import { getUsersHistoriesPaginatedEndpoint } from "../../../services/history/historyService";
import UsersTable from "./UsersTable";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import Loader from "../../../components/common/Loader";

function UsersTab({ page = 1, pageSize = 10, query = "" }) {
  const [currentPage, setCurrentPage] = useState(page);
  const [queryFilter, setQueryFilter] = useState(query);
  const [usersPaginator] = useFetch(
    getUsersHistoriesPaginatedEndpoint({
      page: currentPage,
      pageSize,
      query: queryFilter,
    })
  );

  const onPageChanged = (targetPage) => {
    setCurrentPage(targetPage);
  };

  const filterUsers = (value) => {
    setQueryFilter(value.trim());
  };

  /**
   * Debounce of updates of query text.
   *
   * The purpose of using a debounced function is to limit the number of times filterStore function is called
   * during a specific time period (300ms).
   *
   * This improves the performance of the application by reducing the number of unnecessary queries.
   *
   * @type {DebouncedFunc<filterUsers>}
   */
  const debouncedOnQueryChanged = useMemo(() => debounce(filterUsers, 300), []);

  if (usersPaginator === null) {
    return <Loader />;
  }

  return (
    <Container fluid>
      <Row>
        <Col md="4">
          <Input
            name="filter_store"
            id="filter_store"
            placeholder="search by username or email"
            onChange={(e) => debouncedOnQueryChanged(e.currentTarget.value)}
          />
        </Col>
      </Row>
      <Row className="pt-2">
        <UsersTable users={usersPaginator.results} />
      </Row>
      <Row>
        <Pagination
          label="users"
          itemsCount={usersPaginator.count}
          pageSize={pageSize}
          currentPage={currentPage}
          onPageChange={onPageChanged}
        />
      </Row>
    </Container>
  );
}

UsersTab.propTypes = {
  page: PropTypes.number,
  pageSize: PropTypes.number,
  query: PropTypes.string,
};

export default UsersTab;
